import { GetterTree } from 'vuex'
import State from './types'
import { RootState } from '../types'

export const getters: GetterTree<State, RootState> = {
  customer({ activeCustomer }) {
    return activeCustomer
  },
  customers({ customers }) {
    return customers
  },
  customerShipTos({ shipTos }) {
    return shipTos.List
  },
  customerLoading({ loading }) {
    return loading
  },
  errorMessage({ error }) {
    return error
  },
}
